import { CustomFieldImport } from '../translations-types';

const translations: CustomFieldImport = {
  title: 'Import customer label from CSV',
  description:
    'Upload a CSV, choose a customer label and select which column holds the email addresses. Customers matched by email get the customer label turned on.',
  selectField: 'Customer label',
  selectFieldPlaceholder: 'Choose a customer label',
  uploadFile: 'Choose CSV',
  fileContainsHeader: 'First row is a header',
  emailColumn: 'Email column',
  selectEmailColumn: 'Choose the email column',
  column: 'Column',
  matched: 'Matched',
  alreadySet: 'Already set',
  toSet: 'Will be set',
  notFound: 'Not found',
  notFoundHint: 'These email addresses from the CSV do not exist in Re-sence.',
  apply: 'Apply',
  applied: 'Customers updated',
  parseError: 'Could not read the CSV file.',
  emptyFile: 'The file contains no rows.',
  noEmailInColumn: 'No email addresses in this column.',
};

export default translations;
